import React from "react";
import "react-tabs/style/react-tabs.css";
import "./tabs.scss";
import * as ReactTabs from "react-tabs";

export const Tabs = ReactTabs.Tabs;

export const Tab = props => (
  <ReactTabs.Tab {...props} className={["redcircle-lite-tab"].concat(props.className)}>
    {props.children}
  </ReactTabs.Tab>
);
Tab.tabsRole = "Tab";

export const TabPanel = props => (
  <ReactTabs.TabPanel className={["redcircle-lite-tab-panel"].concat(props.className)} {...props}>
    {props.children}
  </ReactTabs.TabPanel>
);
TabPanel.tabsRole = "TabPanel";

export const TabList = props => (
  <ReactTabs.TabList className={["redcircle-lite-tab-list"].concat(props.className)} {...props}>
    {props.children}
  </ReactTabs.TabList>
);
TabList.tabsRole = "TabList";
